import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../../../ui/dialog';
import { Button } from '../../../ui/button';
import { Label } from '../../../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../ui/select';

interface AddStrikeDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  userName: string;
  currentStrikeCount: number;
}

const STRIKE_REASONS = [
  { value: 'Laziness', label: 'Laziness' },
  { value: 'Sexting quality', label: 'Sexting quality' },
  { value: 'No smart messages', label: 'No smart messages' },
  { value: 'Not unsending mass dms', label: 'Not unsending mass dms' },
  { value: 'Other (write in notes)', label: 'Other (write in notes)' }
];

export function AddStrikeDialog({
  isOpen,
  onClose,
  onConfirm,
  userName,
  currentStrikeCount
}: AddStrikeDialogProps) {
  const [selectedReason, setSelectedReason] = useState<string>('');

  const handleConfirm = () => {
    if (selectedReason) {
      onConfirm(selectedReason);
      setSelectedReason('');
      onClose();
    }
  };

  const handleClose = () => {
    setSelectedReason('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Add Strike to {userName}</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label>Current strikes: {currentStrikeCount}/3</Label>
            {currentStrikeCount >= 3 && (
              <p className="text-sm text-brand-red">
                This user already has 3 strikes. No more strikes can be added.
              </p>
            )}
          </div>
          {currentStrikeCount < 3 && (
            <div className="grid gap-2">
              <Label htmlFor="strike-reason">Strike reason</Label>
              <Select value={selectedReason} onValueChange={setSelectedReason}>
                <SelectTrigger id="strike-reason">
                  <SelectValue placeholder="Select a reason" />
                </SelectTrigger>
                <SelectContent>
                  {STRIKE_REASONS.map((reason) => (
                    <SelectItem key={reason.value} value={reason.value}>
                      {reason.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          {currentStrikeCount < 3 && (
            <Button onClick={handleConfirm} disabled={!selectedReason}>
              Add Strike
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}